import { useMount } from "ahooks";
import isString from "lodash/isString";
import { useRouter } from "next/router";
import type { CustomContentProps } from "notistack";
import { SnackbarContent } from "notistack";
import type { FunctionComponentWithRef } from "react";

import { useAppPromotionTracking } from "scmp-app/components/common/snackbar/app-promotion-item/hooks";

import { ArrowIcon, CloseIcon, Content, Message, PhoneIcon } from "./styles";

export type AppPromotionSnackbarItemProps = { onClickClose?: () => void };
export type Props = AppPromotionSnackbarItemProps & CustomContentProps;

export const AppPromotionSnackbarItem: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  onClickClose,
  ref: forwardReference,
}) => {
  const router = useRouter();
  const { trackCloseButtonClick, trackDownloadButtonClick, trackImpression } =
    useAppPromotionTracking();

  const handleClick = () => {
    trackDownloadButtonClick();
    const oneLinkArticle = new URL("https://scmp.onelink.me/3586748601/thaczxeh");
    oneLinkArticle.searchParams.set("deep_link_value", window.location.pathname);
    if (isString(router?.query?.share)) {
      oneLinkArticle.searchParams.set("share", router.query.share);
    }
    window.location.href = oneLinkArticle.toString();
  };

  const handleClose = (event: React.MouseEvent) => {
    event.stopPropagation();
    trackCloseButtonClick();
    onClickClose?.();
  };

  useMount(() => {
    trackImpression();
  });

  return (
    <SnackbarContent ref={forwardReference} role="banner">
      <Content onClick={handleClick}>
        <Message>
          GET THE APP FOR
          <br />7 DAYS FREE
        </Message>
        <PhoneIcon />
        <ArrowIcon />
        <CloseIcon onClick={handleClose} />
      </Content>
    </SnackbarContent>
  );
};

AppPromotionSnackbarItem.displayName = "AppPromotionSnackbarItem";
